import { useState } from 'react';
import { Form as FormAntd, Modal, notification } from 'antd';
import { balancesApi } from 'api/merchants/balance';
import type { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useBalanceTableFiltersStore } from 'store/balanceTableFilters';
import type { TComponent } from 'utils/types/component';

import { Form } from './components/Form';
import { enhanceFormData } from './helpers';

interface IForm {
    currency: string;
    date: [Dayjs, Dayjs];
    email: string;
}
interface IReconciliationModalProps {
    isOpen: boolean;
    closeModal: () => void;
}

const ReconciliationModal: TComponent<IReconciliationModalProps> = (props) => {
    const { isOpen, closeModal } = props;

    const [isLoading, setIsLoading] = useState(false);

    const { t } = useTranslation();

    const [reconciliationForm] = FormAntd.useForm<IForm>();

    const { merchantIdentities } = useBalanceTableFiltersStore('body');

    const handleSumbit = async (data: IForm) => {
        if (merchantIdentities && merchantIdentities.length) {
            try {
                setIsLoading(true);
                const enhancedFormData = enhanceFormData(data);

                await balancesApi.exportReconciliationReport({
                    merchantIdentity: merchantIdentities[0],
                    ...enhancedFormData,
                });

                notification.success({
                    message: 'Акт сверки успешно создан и отправлен на почту.',
                });

                reconciliationForm.resetFields();

                closeModal();
            } catch {
                notification.error({
                    message: t('common.errors.defaultApiError'),
                });
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <Modal
            cancelButtonProps={{ hidden: true }}
            title={t('balance.reconciliationModal.title')}
            confirmLoading={isLoading}
            open={isOpen}
            closable={true}
            okText={t('common.buttons.send')}
            onOk={reconciliationForm.submit}
            onCancel={closeModal}
        >
            <FormAntd
                onFinish={handleSumbit}
                layout='vertical'
                validateTrigger='sumbit'
                form={reconciliationForm}
            >
                <Form />
            </FormAntd>
        </Modal>
    );
};

export { ReconciliationModal };
